// Componente para a aba 8 - Gerenciamento dos Documentos.

import React, { useState } from "react";
import axios from "axios";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const DocumentosTabAners = ({
    id,
    token,
    idProcess,
    responseDocs,
    selectedDocs,
    setResponseDocs,
    setSelectedDocs,
    setIsDownloading,
    isDownloading,
    fileList,
    responseParam,
    dataFormato
}) => {
    // Estado para controlar quantos arquivos foram selecionados para upload
    const [selectedFilesCount, setSelectedFilesCount] = useState(0);

    function removeDocs(i) {
        const upload = document.querySelector("#drop-file");
        const divUpload = document.querySelector("#novoDocumento");
        const attachments = divUpload.querySelectorAll(".row"); // obtém todos os elementos .row dentro do divUp1

        let files = upload.files;
        const dt = new DataTransfer();
        for (let c = 0; c < files.length; c++) {
            console.log("++++++++++", files[c]);
            if (c !== i) {
                dt.items.add(files[c]);
            }
        }

        const newFiles = dt.files;
        console.log(newFiles[0]);
        upload.files = newFiles;
        console.log(upload.files[0]);
        // Remove o elemento no índice i da lista de anexos
        console.log("Antes de remover: " + i);
        console.log(attachments);
        fileList.items.remove(i);
        attachments[i].remove();
        const newDivUpload = document.querySelector("#novoDocumento");
        const icon = newDivUpload.querySelectorAll("i");
        const attach = newDivUpload.querySelectorAll(".row");
        console.log("len: " + icon.length);
        for (let cont = 0; cont < icon.length; cont++) {
            console.log(cont);
            icon[cont].onclick = () => removeDocs(cont);
        }

        // Atualiza a contagem dos arquivos selecionados
        setSelectedFilesCount(newFiles.length);
    }

    function deleteDocumento(n) {
        axios
            .post(
                `/api/remove/document/${n}`,
                { token, responseParam },
                {
                    withCredentials: true,
                    timeout: 10000,
                }
            )
            .then((response) => {
                window.location = response.data;
            })
            .catch((error) => {
                if (axios.isAxiosError(error)) {
                    console.error("Erro Axios:", error.message);
                    console.error("Configuração da solicitação:", error.config);
                } else {
                    console.error(
                        "Erro não relacionado ao Axios:",
                        error.message
                    );
                }
            });
    }

    // Função para excluir os documentos selecionados
    const deleteSelected = async () => {
        if (selectedDocs.length === 0) {
            alert("Selecione ao menos um documento para excluir.");
            return;
        }
        if (
            !window.confirm(
                "Tem certeza de que deseja excluir os documentos selecionados?"
            )
        ) {
            return;
        }
        try {
            // Exclui cada documento selecionado
            await Promise.all(
                selectedDocs.map(async (docId) => {
                    // Use axios.post ou axios.delete conforme sua API (aqui usamos axios.post como exemplo)
                    const response = await axios.post(
                        `/api/remove/document/${docId}`,
                        null,
                        { withCredentials: true }
                    );
                    if (response.data.status !== 200) {
                        throw new Error(`Erro ao excluir documento ${docId}`);
                    }
                })
            );
            // Atualiza a lista removendo os documentos excluídos
            setResponseDocs((prevDocs) =>
                prevDocs.filter((doc) => !selectedDocs.includes(doc.id))
            );
            setSelectedDocs([]);
        } catch (error) {
            console.error("Erro ao excluir os documentos selecionados:", error);
            window.location.reload();
        }
    };

    // Função para excluir TODOS os documentos
    const deleteAll = async () => {
        if (responseDocs.length === 0) {
            alert("Não há documentos para excluir.");
            return;
        }
        if (
            !window.confirm(
                "Tem certeza de que deseja excluir todos os documentos?"
            )
        ) {
            return;
        }
        try {
            await Promise.all(
                responseDocs.map(async (doc) => {
                    const response = await axios.post(
                        `/api/remove/document/${doc.id}`,
                        null,
                        { withCredentials: true }
                    );
                    if (response.data.status !== 200) {
                        throw new Error(`Erro ao excluir documento ${doc.id}`);
                    }
                })
            );
            // Limpa a lista de documentos e os selecionados
            setResponseDocs([]);
            setSelectedDocs([]);
        } catch (error) {
            console.error("Erro ao excluir todos os documentos:", error);
            window.location.reload();
        }
    };

    // Função para lidar com a seleção de um único documento
    const handleSelectDoc = (id) => {
        setSelectedDocs((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((docId) => docId !== id)
                : [...prevSelected, id]
        );
    };

    // Função para selecionar ou desmarcar todos os documentos
    const handleSelectAll = () => {
        if (selectedDocs.length === responseDocs.length) {
            setSelectedDocs([]);
        } else {
            setSelectedDocs(responseDocs.map((doc) => doc.id));
        }
    };

    // Função para baixar documentos selecionados
    const downloadSelected = () => {
        if (selectedDocs.length === 0) return;

        setIsDownloading(true);
        selectedDocs.forEach((docId) => {
            const link = document.createElement("a");
            link.href = `https://guias.almeidaenogueira.com.br/api/download/documento/${docId}`;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
        setIsDownloading(false);
    };

    // Função para baixar todos os documentos
    const downloadAll = async () => {
        const zip = new JSZip();
        await Promise.all(responseDocs.map(async doc => {
          const res = await fetch(`/api/download/documento/${doc.id}`, { credentials: 'include' });
          const blob = await res.blob();
          zip.file(doc.nome, blob);
        }));
        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, 'documentos.zip');
    };

    const handleDocsUpload = (event) => {
        let file = event.target.files;
        // Atualiza o estado com a quantidade de arquivos selecionados
        setSelectedFilesCount(file.length);

        for (let i = 0; i < file.length; i++) {
            fileList.items.add(file[i]);
            const divUpload = document.querySelector("#arquivosAdd");
            //const newAtt = document.querySelector('#newAttach');
            const novos = document.querySelector("#novoDocumento");
            const rowDiv = document.createElement("div");
            rowDiv.className = "row";

            const col7Div = document.createElement("div");
            col7Div.className = "col-12";

            const label = document.createElement("label");
            label.textContent = `${file[i].name}`;
            const spanUpload = document.createElement("span");
            spanUpload.className = "hidden-xs";
            const iconUp = document.createElement("i");
            iconUp.className =
                "fa fa-minus-circle ml-3 btn-remove-anexo text-danger";
            iconUp.style.fontSize = "1.25em";
            iconUp.style.position = "relative";
            iconUp.style.top = ".15em";
            iconUp.onclick = () => removeDocs(i);
            spanUpload.appendChild(iconUp);
            col7Div.appendChild(label);
            col7Div.appendChild(spanUpload);
            rowDiv.appendChild(col7Div);

            //divUpload.insertBefore(rowDiv, newAtt)
            novos.appendChild(rowDiv);
        }

        event.target.files = fileList.files;
        console.log("Files: " + file);

        const newDivUpload = document.querySelector("#novoDocumento");
        const icon = newDivUpload.querySelectorAll("i");
        for (let i = 0; i < icon.length; i++) {
            icon[i].onclick = () => removeDocs(i);
        }
    };

    return (
        <div className="tab-pane fade" id={id} role="tabpanel">
            <div className="card-body table-responsive p-0">
                <table className="table table-striped table-bordered mt-10">
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={
                                        selectedDocs.length ===
                                        responseDocs.length
                                    }
                                />
                            </th>
                            <th>Nome do Arquivo</th>
                            <th>Data da Inserção do Arquivo</th>
                            <th>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {responseDocs.map((dados) => (
                            <tr key={dados.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedDocs.includes(
                                            dados.id
                                        )}
                                        onChange={() =>
                                            handleSelectDoc(dados.id)
                                        }
                                    />
                                </td>
                                <td>
                                    <a
                                        style={{ color: "green" }}
                                        href={`https://guias.almeidaenogueira.com.br/api/download/documento/${dados.id}`}>
                                        {dados.nome}
                                    </a>
                                </td>
                                <td>{dataFormato(dados.data)}</td>
                                <td>
                                    <button
                                        onClick={() =>
                                            deleteDocumento(dados.id)
                                        }
                                        className="btn btn-danger"
                                        title="Excluir">
                                        Excluir
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="mt-3">
                    <button
                        className="btn btn-primary mr-2"
                        onClick={downloadSelected}
                        disabled={selectedDocs.length === 0 || isDownloading}>
                        {isDownloading ? "Baixando..." : "Baixar Selecionados"}
                    </button>
                    <button
                        className="btn btn-secondary"
                        onClick={downloadAll}
                        disabled={isDownloading}>
                        {isDownloading ? "Baixando..." : "Baixar Todos"}
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={deleteSelected}
                        disabled={selectedDocs.length === 0}>
                        Excluir Selecionados
                    </button>
                    <button
                        className="btn btn-warning"
                        onClick={deleteAll}
                        disabled={responseDocs.length === 0}>
                        Excluir Todos
                    </button>
                </div>
            </div>
            <form
                action={`/api/novo/documento/${idProcess}`}
                method="post"
                encType="multipart/form-data">
                <div
                    className="row"
                    id="pagamentoAnexo"
                    style={{ visibility: "visible", display: "block" }}>
                    <div className="col-12 center-element p-2">
                        <label>Suba aqui seu arquivo:</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 center-element p-2">
                        <div className="file-drop-area">
                            <span className="choose-file-button">
                                Escolha o arquivo
                            </span>
                            <span className="file-message">
                                ou arraste e solte ele aqui
                            </span>
                            <input
                                name="upload"
                                id="drop-file"
                                className="file-input"
                                type="file"
                                onChange={handleDocsUpload}
                                multiple
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12" id="novoDocumento"></div>
                <div className="row">
                    <div className="col-12 center-element p-2">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={selectedFilesCount === 0}>
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default DocumentosTabAners;
